module.exports = __webpack_public_path__ + "img/train-intro5.a5641b21.jpg";